import { AuthReducer,credentialReducer } from "./reducers";

import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';



const rootReducer = combineReducers({
    "Auth": AuthReducer,
    "Credential": credentialReducer,

})

const middleware = [thunkMiddleware];

const composeEnhancers =
    typeof window === 'object' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        }) : compose;

const enhancer = composeEnhancers(
    applyMiddleware(...middleware),
    // other store enhancers if any
);

const Store = createStore(
    rootReducer,
    enhancer
);

export default Store;

